import {PhoneInput} from '../../../components/Input/PhoneInput'
import type {PhoneInputWidgetProps as Props} from '../../types'

export const PhoneInputWidget = ({config: {height, placeholder, form_state_key}}: Props): React.ReactElement => {
  return <PhoneInput height={height} name={form_state_key} placeholder={placeholder} />
}
